import Vue from 'vue';

import * as Sentry from '@sentry/vue';

import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';

// import Router from "vue-router";

// Import custom globally plugins and directives
import './filters';
import './plugins';
import './directives';

Vue.config.productionTip = false;
Vue.router = router;

// Chrome fires this as a window error event even though nothing is broken -
// it's a benign browser quirk with ResizeObserver-based libraries (e.g. FullCalendar).
// Suppress it so the dev-server overlay doesn't treat it as an uncaught error
// and it doesn't end up in Sentry as noise.
// Registered in the capture phase so it runs before the overlay's own listener.
window.addEventListener('error', (event) => {
  if (event.message === 'ResizeObserver loop completed with undelivered notifications.'
    || event.message === 'ResizeObserver loop limit exceeded') {
    event.stopImmediatePropagation();
  }
}, { capture: true });

const config = process.env.NODE_ENV === 'production' ? '/config.json' : '/config.local.json';
await axios.get(config).then((response) => {
  const { data } = response;
  Vue.prototype.$config = data;
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: data.environment,
    release: process.env.VUE_APP_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    tracePropagationTargets: [data.baseApiUrl],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });

  new Vue({
    name: 'MelonWebUI',
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
});
